// TODO: Maybe move these to a separate file now?
export const {
    LOG_LEVEL,
    IS_PRODUCTION,
    TEST_MODE,
    BLINK_PAY_URL,
    BLINK_API_URL,
    PUBLIC_DATA_BASE_URL,
    BUILD_VERSION,
    BUILD_TIMESTAMP,
    ANALYTICS_ENABLED,
    ANALYTICS_ENDPOINT,
    WS_API_URL,
    STRIPE_PUBLIC_KEY,
    GOOGLE_PAY_ENV,
    LINKEDIN_CLIENT_ID,
    GOOGLE_CLIENT_ID,
    FACEBOOK_CLIENT_ID,
    TWITTER_CLIENT_ID,

    // TODO: Remove this from configuration files once we support forms in a non-hardcoded way.
    SOUTHERN_THING_ALIAS,
    TNR_ALIAS,

// DEPLOY_CONFIG is replaced at build time with the configuration JSON.
// See the replace({...}) plugin in BundleDescription's getRollupPlugins()
// and getDeployConfig() in buildEnvironment.js
} = DEPLOY_CONFIG;

export const BLINK_SDK_READY_EVENT = "blinkSDKReady";

export const IFRAME_HTML_FILE = "iframe.html";
export const IFRAME_APP_TYPE = {
    widget: "widget",
    paywall: "paywall",
};

export const IFRAME_TEST_ID = {
    widgetCloseButton: "blinkWidgetCloseButton",
    widget: "blinkWidgetIframe",
    widgetButton: "blinkWidgetButton",
    donation: "blinkDonationIframe",
    payment: "blinkPaywallIframe",
    subscribe: "blinkPaywallSubscribe",
    newsletter: "blinkNewsletterIframe",
    identity: "blinkIdentityIframe",
    modal: "blinkModalIframe",
    error: "blinkErrorIframe",
};

export const PANEL_TYPE = {
    identity: "identity",
    subscribe: "subscribe",
    payment: "payment",
    donation: "donation",
    donationPage: "donationPage",
    custom: "custom",
    newsletter: "newsletter",
    dashboard: "dashboard",
};

export const AUTHENTICATION_PANEL_TYPE = "internalAuthentication";

export const PANEL_TEST_ID = {
    [PANEL_TYPE.identity]: IFRAME_TEST_ID.identity,
    [PANEL_TYPE.subscribe]: IFRAME_TEST_ID.subscribe,
    [PANEL_TYPE.payment]: IFRAME_TEST_ID.payment,
    [PANEL_TYPE.donation]: IFRAME_TEST_ID.donation,
    [PANEL_TYPE.newsletter]: IFRAME_TEST_ID.newsletter,
    [AUTHENTICATION_PANEL_TYPE]: IFRAME_TEST_ID.modal,
};

export const GATE_TYPE = {
    null: "null",
    cover: "cover",
    preview: "preview",
    popup: "popup",
    banner: "banner",
};

export const GATE_COVER_PANEL_POSITION = {
    top: "top",
    center: "center",
    bottom: "bottom",
};

export const PANEL_FOOTER_THEME = {
    default: "default",
    reversed: "reversed",
};

export const DEFAULT_PAYWALL_CONTAINERS = [
    {
        selector: ".blink-container,#blink-container",
        panelType: PANEL_TYPE.payment,
        gateType: GATE_TYPE.null,
    },
    {
        selector: ".blink-donation-container,#blink-donation-container",
        panelType: PANEL_TYPE.donation,
        gateType: GATE_TYPE.null,
    },
    {
        selector: ".blink-subscription-container,#blink-subscription-container",
        panelType: PANEL_TYPE.subscribe,
        gateType: GATE_TYPE.preview,
    },
    {
        selector: ".blink-purchase-container,#blink-purchase-container",
        panelType: PANEL_TYPE.payment,
        gateType: GATE_TYPE.preview,
    },
    {
        selector: ".blink-newsletter-container,#blink-newsletter-container",
        panelType: PANEL_TYPE.newsletter,
        gateType: GATE_TYPE.null,
    },
];
export const PG_INSERTED_ATTR = "data-blink-paywall-inserted";

export const USER_JOURNEY_ACTION_TYPE = {
    blinkAction: "blinkAction",
    createPG: "createPG",
    callback: "callback",
};

export const DONATION_COOLDOWN_PERIOD = 48 * 60 * 60 * 1000; // 48 hours

export const WALL_TRANSITION_TIME = 200;
export const WALL_TRANSITION = WALL_TRANSITION_TIME + "ms ease";
export const WIDGET_BACKGROUND = "linear-gradient(60deg, #085B68, #064953)";
export const POPUP_GATE_TRANSITION_TIME = 300;
export const MIN_SUPPORTED_WINDOW_WIDTH = 375;
export const ANALYTICS_SUBMIT_DEBOUNCE_MS = 100;
export const ANALYTICS_SDK_UPDATE_ENVIRONMENT_THROTTLE_MS = 50;
export const ANALYTICS_MAX_QUEUED_MESSAGES = 16;

export const MERCHANT_STORAGE_KEY_PREFIX = "blink-|-";

// The whitelist of keys we may add to the host website's localStorage
// or sessionStorage. The real keys used in the storage will have a
// prefix that almost guarantees uniqueness ("blink-|-").
export const MERCHANT_STORAGE_KEYS = {
    loggerLevel: "Logger.loggerLevel",
    onBoardingBehaviour: "UXManager.onboardingBehaviour",
    merchantSessionId: "Analytics.sessionId",
    merchantLocalId: "Analytics.localId",
    selectedUserJourneys: "UJ-selected",
    nthPageVisitConditionState: "UJ-visits-",
    variables: "variables",
    authToken: "authToken",
    utm: "utm",
};

export const UTM_PARAM_KEYS = ["medium", "campaign", "source", "term", "content"];

export const INSUFFICIENT_FUNDS_ERROR_CODE = 1207;

export const ACCESS_AUTHORIZATION_REJECTED_ERROR_CODE = 1911;
export const ACCESS_AUTHORIZATION_REJECTED_ERROR_MESSAGE = "The user refused to grant access to his profile details.";

export const PANEL_VARIANT = {
    plain: "plain",
    adBlock: "adBlock",
    skipCTA: "skipCTA",
    editRecurring: "editRecurring",
};

export const PANEL_FRAME = {
    none: "none",
    logo: "logo",
};

export const GATE_MOUNT_TYPE = {
    replaceChildren: "replaceChildren",
    firstChild: "firstChild",
    lastChild: "lastChild",
};

export const SOCIAL_APPS = {
    Facebook: "Facebook",
    Google: "Google",
    Twitter: "Twitter",
    LinkedIn: "LinkedIn",
    CDS: "CDS",
}
